import React from 'react';
import { Timeline } from 'antd';

import { Colors } from '@common/tokens';
import { HighlightWords } from '@common/components';
import { TimeWithTimeZone } from '@common/components/time-with-time-zone';
import { HistoryInfoFragmentFragment } from '@common/graphql/schema';
import { historyRenderChange } from '@common/components/history/history-render-change';

const HistoryChanges = ({
  data,
}: {
  data: HistoryInfoFragmentFragment['changes'];
}) => {
  if (!data?.length) {
    return <></>;
  }

  return (
    <div className="HistoryChanges">
      {data
        .filter(
          (item) =>
            item.valueBefore !== item.valueAfter ||
            item.dataBefore !== item.dataAfter
        )
        .map((item, key) => (
          <React.Fragment key={key}>
            {historyRenderChange?.(item)}
          </React.Fragment>
        ))}
      <style jsx>{`
        :global(.HistoryChanges .value-after) {
          font-weight: 500;
        }
        :global(.HistoryChanges .value-after-none) {
          color: ${Colors.midnightLightest};
          font-weight: 500;
        }
        :global(.HistoryChanges .value-after.addition) {
          color: ${Colors.grassMid};
        }
        :global(.HistoryChanges .value-before) {
          color: ${Colors.midnightLightest};
          text-decoration-line: line-through;
          margin-right: 4px;
        }
      `}</style>
    </div>
  );
};

export const History = ({ data }: { data?: HistoryInfoFragmentFragment[] }) => {
  if (!data?.length) {
    return <></>;
  }

  return (
    <>
      <Timeline className="History sentry-mask">
        {data.map((item, key) => {
          return (
            <Timeline.Item key={key} color={Colors.midnightLightest}>
              <HighlightWords
                className="mb-4"
                phrase={item.text}
                highlights={item.textHighlightedWords || []}
              />
              {item.description && <p className="mb-4">{item.description}</p>}
              <HistoryChanges data={item.changes} />
              <div className="pt-4">
                <span className="datetime">
                  <TimeWithTimeZone date={item.date} variant="long_format" />
                </span>
              </div>
            </Timeline.Item>
          );
        })}
      </Timeline>
      <style jsx>{`
        :global(.History .mb-4) {
          margin-bottom: 4px;
        }
        :global(.History .pt-4) {
          padding-top: 4px;
        }
        :global(.History .ant-timeline-item-last) {
          padding-bottom: 0;
        }
        :global(.History .ant-timeline-item) {
          padding-bottom: 16px;
        }
        :global(.History .ant-timeline-item-content) {
          margin: 0 0 0 24px;
        }
        :global(.History .datetime) {
          font-size: 12px;
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </>
  );
};
